<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : activeStep == step }" (click)="toggleOpen()">
        <span class="margin-right">Location Information</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <location-point [application]="application" [form]="form?.get('points')?.get(pointTypes.WellHead)" [point]="pointTypes.WellHead" (notesRequested)="handleNoteRequested($event)"></location-point>
    @if (form?.get('slant')?.value == directions.Horizontal || form?.get('slant')?.value == directions.OtherHorizontal) {
      <location-point [application]="application" [form]="form?.get('points')?.get(pointTypes.Heel)" [point]="pointTypes.Heel" (notesRequested)="handleNoteRequested($event)"></location-point>
      <location-point [application]="application" [form]="form?.get('points')?.get(pointTypes.Toe)" [point]="pointTypes.Toe" (notesRequested)="handleNoteRequested($event)"></location-point>
    }
    @if (form?.get('slant') != null && form?.get('slant')?.value != directions.Vertical) {
      <location-point [application]="application" [form]="form?.get('points')?.get(pointTypes.Target)" [point]="pointTypes.Target" (notesRequested)="handleNoteRequested($event)"></location-point>
    }
  </div>
</ng-container>